import { useState, useEffect } from 'react';

export const useContentCarousel = ({ courseContentList }) => {
  const [temporal, setTemporal] = useState([]);

  useEffect(() => {
    if (courseContentList?.length > 0) {
      let contentList = [];

      const hasParent = (contentElement) => {
        // Cambiado de 'course_topic' a 'main_course_topic'
        return contentElement.main_course_topic != null && contentElement.main_course_topic != undefined;
      };

      const hasChildren = (contentElement) => {
        let isParent;
        for (let index = 0; index < courseContentList.length; index++) {
          const element = courseContentList[index];
          // Cambiado de 'course_topic' a 'main_course_topic'
          if (element.main_course_topic == contentElement.id) {
            isParent = true;
            break;
          } else {
            isParent = false;
          }
        }
        return isParent;
      };

      const isSubParent = (contentElement) => {
        return hasChildren(contentElement) && hasParent(contentElement);
      };

      courseContentList
        .sort((a, b) => parseInt(a?.order ?? a?.id) - parseInt(b.order ?? b?.id))
        .forEach((content) => {
          if (content.main_course_topic == null) {
            const contentObject = {
              title: '',
              description: []
            };
            contentObject.title = content.name;
            courseContentList.forEach((courseContent) => {
              if (isSubParent(courseContent) && courseContent.main_course_topic == content.id) {
                contentObject.description.push(
                  <>
                    <li>
                      {courseContent.name}
                      <ul
                        style={{
                          paddingLeft: '20px'
                        }}>
                        {courseContentList.map(
                          (c) =>
                            c.main_course_topic == courseContent.id &&
                            c.name
                              .split('<br>')
                              .map((desc) => desc.length > 0 && <li>{desc}</li>)
                        )}
                      </ul>
                    </li>
                  </>
                );
              } else if (courseContent.main_course_topic == content.id) {
                contentObject.description.push(
                  <>
                    {courseContent.name
                      .split('<br>')
                      .map((c) => c.length > 0 && <li>{c}</li>)}
                  </>
                );
              }
            });

            contentList.push(contentObject);
          }
        });

      contentList = contentList
        .filter((content) => {
          return content.description.length > 0;
        })
        .map((content, index) => ({ ...content, index }));
      setTemporal(contentList);
    }
  }, [courseContentList]);

  return {
    temporal
  };
};